import { useTypedSelector } from '../redux/store';
import { selectAuth } from '../redux/slice/AuthSlice';
import { isMobile } from '../env';

export function useThemeMode() {
  const is_mobile = isMobile();
  let themeMode = useTypedSelector((state) => selectAuth(state)).themeMode;
  // os is for backward compatible
  if(is_mobile){
    themeMode = 'dark';
  }else if (!themeMode || ['default', 'os'].includes(themeMode)) {
    // follow os mode
    const themeMedia = window.matchMedia('(prefers-color-scheme: light)');
    themeMode = themeMedia.matches ? 'light' : 'dark';
  }

  return themeMode === 'light' ? 'light' : 'dark';
}